/**
 * Organization state.
 */
import { make } from "vuex-pathify";
import api from "@/api";
import _ from "lodash";

const endPoint = api.props.endPoints.organization;

const state = {
  organization: { address: {}, primaryContact: {}, userIds: [] },
  ogOrganization: {},
  errorsOccurred: false
};

// automatically generate getters
const getters = make.getters(state);

const mutations = {
  ...make.mutations(state),
  // override
  setOrganization(state, organization) {
    state.organization = organization;
    state.ogOrganization = this.copy("organization/organization");
  },
  setErrorsOccurred(state, value) {
    state.errorsOccurred = value;
  },
  cleanOrganization(state) {
    state.ogOrganization = _.cloneDeep(state.organization);
  },
  rollbackOrganization(state) {
    state.organization = _.cloneDeep(state.ogOrganization);
  }
};

const actions = {
  ...make.actions(state),

  loadOrganization({ commit }, id) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve) {
      api
        .getEntity(endPoint, id)
        .then(organization => {
          if (Array.isArray(organization)) {
            for (var i = 0; i < organization.length; i++) {
              if (organization[i].id == id) {
                commit("setOrganization", organization[i]);
                break;
              }
            }
          } else {
            commit("setOrganization", organization);
          }
          resolve(organization);
        })
        .catch(ex => {
          commit("setErrorsOccurred", true);
          commit(
            "pushError",
            ex.msg || ex.value || "Failed to load API organization.",
            {
              root: true
            }
          );
        });
    });
  },
  updateOrganization({ commit }, dirtyOrganization) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve) {
      api
        .setEntity(endPoint, dirtyOrganization)
        .then(() => {
          commit("cleanOrganization", dirtyOrganization);
          resolve(state.organization);
        })
        .catch(ex => {
          commit("setErrorsOccurred", true);
          commit("rollbackOrganization");
          commit(
            "pushError",
            ex.msg ||
              `Failed to update API Organization "${dirtyOrganization.name}".`,
            {
              root: true
            }
          );
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
